export default __webpack_public_path__ + "57186087be2b8910d09258dfcdb9e0e2.svg";